import {ProductPriceMapping} from "../../common/models/StoreProductPrice";
import {IInvestStoreProduct} from "./IInvestStoreProduct";

export const IInvestStorePriceMapping: ProductPriceMapping<IInvestStoreProduct> = {
    PLATFORM: 100
};
